import { http, https } from '../../global/axios';
import { expNum } from '@/global/utils';
import qs from 'qs'

// 任务列表
export const list = (params) => {
  return http.post(`v2/tags/task/list.json`, params);
};

// 任务详情
export const detail = (params) => {
  return https.post(`v2/tags/task/module/get/${params.id}.json`);
};
// 用户质检权限
export const auth = () => {
  return http.get(`v2/tags/lib/check/qc/auth.json`);
};

// 获取任务分类
export const getCategory = () => {
  return http.post(`v1/skill/category.json`);
};
// 任务详情帮助文档 普通任务、团队任务、练习任务公用
export const helps = (params = {
  gid: ''
}) => {
  return http.post(`v1/team/offline/leader/tags/helps.json`, params);
};
// 任务详情帮助文档 快判任务
export const judgeHelps = (params = {
  gid: ''
}) => {
  return http.post(`/v1/judge/study/data.json?gid=${params.gid}`);
};
// 更新跳转页面form类型
export const getFromType = (params) => {
  return http.post(`v1/tags/study/detail.json?gid=${params.gid}`);
};
// 获取标注示例
export const getCase = (params) => {
  return http.post(`/v2/tags/lib/check/good_bad/first_lib.json`, params);
};
// 全局搜索
export const searchAll = (params) => {
  return http.post(`v2/tags/task/search/list.json`, params);
};
// 获取任务发布人
export const getOwner = () => {
  return http.get(`v2/tags/task/owner.json`);
};
//获取七牛token
export const getQiniuToken = () => {
  return http.get(`v1/sdk/qiniu/token.json`);
};
//partnerPage批量做题
export const partnerBatchAnswer = (params) => {
  return https.post(`v2/tags/lib/partner/batch/answer.json`, params);
};
//partnerPage批量导出
export const partnerBatchDownload = (params) => {
  return https.post(`v2/tags/lib/partner/batch/download.json`, params);
}
//partnerPage批量审核
export const partnerBatchCheck = (params) => {
  return https.post(`v2/tags/lib/partner/batch/check.json`, params);
};
/**
 *  新审核根据索引查询题ID
 */
export const newCheckId = (params) => {
  return http.post(`v2/tags/lib/module/check/ids.json`, params);
};
//partnerPage批量导出-全部
export const partnerDownloadAll = (params) => {
  return https.post(`v2/tags/lib/partner/download/all.json`, params);
}
/**
 *  查看题包列表信息
 */
export const pkgList = (params) => {
  return http.post(`v2/tags/task/module/pkginfo/list.json`, params);
};
// 题包详情
export const pkgInfo = (params) => {
  return https.post(`v2/tags/task/module/pkginfo/${params.pkg_id}/${params.type}.json`);
};
//锁题记录
export const pkgUnlock = (params) => {
  return https.post(`v2/tags/task/module/libs/unlock.json?pkg_id=${params.pkg_id}&mlid=${params.mlid}`);
};
export const pkgListByProjectId = (params) => {
  return http.post(`v2/tags/task/module/pkginfo/pid.json`, params);
};

//审核、质检人员列表
export const useStatisticList = (params) => {
  return http.post(`v2/tags/lib/modules/query/statistic/${params.mid}.json`, params);
};

//按照人的维度批量审核
export const useBatchCheck = (params) => {
  return http.post(`v2/tags/lib/modules/batch/check.json`, params);
};
/**
 *  导出题包数据
 */
export const exportPkgList = (params) => {
  return https.post(`v2/tags/task/module/pkginfo/list/export.json`, params, { responseType: 'blob' });
};